import React, { Component } from "react";
import { getDownloadCode } from "../../AppCore";

/** Component */
import { SuccessAgreementComponent } from "../Component/SuccessAgreementComponent";
import {SuccessCommitmentComponent} from "../Component/SuccessCommitmentComponent";
import {SuccessNotDownloadPDFComponent} from "../Component/SuccessNotDownloadPDFComponent";

import { route } from "../../AppCore";

class SuccessPageContainer extends Component {
  /**
   * Catch all errors in this component
   * @param error
   * @param errorInfo
   */
  componentDidCatch(error, errorInfo) {
    console.log("Error: ", error, "ErrorInfo: ", errorInfo);
  }

  render() {
    const { downloadFileAvailable } = this.props;
    return (
      downloadFileAvailable === 'AGREEMENT_PDF' ?
        <SuccessAgreementComponent
          downloadLink={route.DOWNLOAD_PDF(getDownloadCode())}
        />
        :
        downloadFileAvailable === 'COMMITMENT_PDF' ?
        <SuccessCommitmentComponent
          downloadLink={route.DOWNLOAD_COMMITMENT_PDF(getDownloadCode())}
        />
        :
        <SuccessNotDownloadPDFComponent/>
    );
  }
}

export default SuccessPageContainer;



// WEBPACK FOOTER //
// ./src/modules/PartnerAgreement/Container/SuccessPageContainer.js